/**
 * Base state for current module
 */
/**
 * Base state for current module
 */
const state = {
  documents: {
    forms: [],
  },
  props: {
    limit: 10,
  },
  defaultProps: [
    {
      key: "limit",
      label: "Limit",
      helperText: "Select the number of items to view (max 30)",
      type: "text",
      value: 10,
      validation: "required:true|between:1,30",
    },
  ],
  propOptions: {},
};

export default state;
